import { Component, Input, OnInit } from '@angular/core';
import { IBallotSearchResult } from '../../models/search/ballot-search-result';
import { UnifiedBallotStatus } from '../../../../../shared/enums/unified-ballot-status-enum';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

export const SummaryComponentView = {vote: 'vote'}

@Component({
    selector: 'app-button-vote-now',
    templateUrl: './button-vote-now.component.html',
    styleUrl: './button-vote-now.component.scss',
    standalone: false
})
export class ButtonVoteNowComponent implements OnInit{

  @Input() ballot!: IBallotSearchResult;
  isButtonVisible: boolean = false;

  constructor(private _modalService: NgbModal, private _router: Router){}

  ngOnInit(): void {
    this.isButtonVisible = this.isVoteNowButtonVisible(this.ballot);
  }

  isVoteNowButtonVisible(ballot: IBallotSearchResult): boolean {
    const result = ballot
      && ballot.statusId === UnifiedBallotStatus.openForVoting
      && ballot.isCurrentUserEligibleVoter
      && !ballot.hasCurrentUserVoted
    return result;
  }

  voteNow(e: Event) {
    const ballotType = this.ballot.ballotType.toLowerCase() == 'sr' ? 'srs' : this.ballot.ballotType.toLowerCase();
    this._router.navigate([`/ballots/${ballotType}/${this.ballot.ballotId}`], {queryParams : SummaryComponentView});
  }
}
